import {
  Wrench,
  ArrowRight,
  PuzzlePiece,
  Cloud,
  Book,
  ClockCounterClockwise,
  CreditCard,
  Download,
} from '@phosphor-icons/react';
import { Card, Flex } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router';
// import PendingModal from '~/components/PendingModal';
import { getPendingModalStore } from '~/components/PendingModal/store';
import { PackagesTabKey } from '~/pages/Packages';
import BalanceModal from '~/pages/Packages/PluginPay/BalanceModal';

interface ToolItem {
  type?: 'link' | 'path' | 'pending' | 'balance' | 'download';
  text: string;
  icon: React.ElementType;
  description: string;
  className: string;
  href?: string;
  path?: string;
  btnText?: string;
}

export const DocsHerf = 'https://jcaigc-doc.feishu.cn/wiki/FlYEwlKusiC6lZkjLcocqZ0LnKe';

const items: ToolItem[] = [
  {
    text: '官方文档',
    icon: Book,
    description: '常见问题解答与插件使用教程',
    className: 'docs-module',
    href: DocsHerf,
  },
  {
    text: '文件上传管理',
    icon: Cloud,
    description: '管理您的文件资源，支持多种格式上传与分享',
    className: 'upload-module',
    path: '/upload',
    btnText: '立即上传',
  },
  {
    text: '插件列表',
    icon: PuzzlePiece,
    description: '浏览和使用各种功能强大的插件工具',
    className: 'plugins-module',
    href: 'https://www.coze.cn/user/1388063163427228?access_entrance=my_profile&sub_tab=plugins&tab=user_product',
  },
  {
    text: '消费明细',
    icon: ClockCounterClockwise,
    description: '查看您的充值和消费明细',
    className: 'balance-module',
    path: `/recharge?type=${PackagesTabKey.CONSUMPTION}`,
  },
  {
    text: '计费标准',
    icon: CreditCard,
    type: 'balance',
    description: '了解各插件使用消耗规则',
    className: 'excel-module',
    path: `/recharge?type=${PackagesTabKey.PRICING}`,
  },
  {
    text: '剪映小助手',
    icon: Download,
    type: 'download',
    description: '提升您的创作效率',
    className: 'docs-module',
    path: `/download`,
    btnText: '立即下载',
  },
];

const MoreTool = () => {
  const navigate = useNavigate();

  const [balanceOpen, setBalanceOpen] = useState(false);

  const handleClick = (item: ToolItem) => {
    if (item.href) {
      window.open(item.href, '_blank');
    } else if (item.path) {
      navigate(item.path);
      // } else if (item.type === 'balance') {
      //   setBalanceOpen(true);
      // } else {
      getPendingModalStore().open = true;
    }
  };
  return (
    <Card
      type="inner"
      className="user-tools-card"
      title={
        <Flex className="card-header tools-section-title" align="center" gap={0}>
          <Wrench className="svg-inline--fa fa-screwdriver-wrench section-icon" />
          更多工具
        </Flex>
      }
    >
      <div className="tools-grid">
        {items.map((item) => (
          <div key={item.text} className={`tool-module ${item.className}`}>
            <div className="tool-icon-wrapper">
              <item.icon className="svg-inline--fa fa-book-open tool-icon" weight="fill" />
            </div>
            <div className="tool-content">
              <h4 className="tool-title">{item.text}</h4>
              <p className="tool-description">{item.description}</p>
              <button className="tool-action-btn" onClick={() => handleClick(item)}>
                {item.btnText || '立即查看'}
                <ArrowRight className="svg-inline--fa fa-arrow-right btn-icon" weight="bold" />
              </button>
            </div>
          </div>
        ))}
      </div>
      {/* <PendingModal /> */}
      <BalanceModal open={balanceOpen} onHideModal={() => setBalanceOpen(false)} />
    </Card>
  );
};

export default MoreTool;
